import { API } from "."
import type {
  ReadPdfTemplatesParams,
  ReadPdfTemplatesResponse,
  ReadPdfTemplateDetailResponse,
  CreatePdfTemplatePayload,
  CreatePdfTemplateResponse,
  UpdatePdfTemplatePayload,
  UpdatePdfTemplateResponse,
} from "@/types/pdfTemplate"

/* PDF 템플릿 목록 조회 */
export async function readPdfTemplates(params?: ReadPdfTemplatesParams) {
  return await API.get<ReadPdfTemplatesResponse>("/pdf-templates", { params })
}

/* PDF 템플릿 상세 조회 */
export async function readPdfTemplateDetail(idfPdfTemplate: number) {
  return await API.get<ReadPdfTemplateDetailResponse>(`/pdf-templates/${idfPdfTemplate}`)
}

/* PDF 템플릿 생성 */
export async function createPdfTemplate(payload: CreatePdfTemplatePayload) {
  return await API.post<CreatePdfTemplateResponse>("/pdf-templates", payload)
}

/* PDF 템플릿 수정 */
export async function updatePdfTemplate(payload: UpdatePdfTemplatePayload) {
  const { idfTemplate, ...body } = payload
  return await API.put<UpdatePdfTemplateResponse>(`/pdf-templates/${idfTemplate}`, body)
}

/* PDF 템플릿 삭제 */
export async function deletePdfTemplate(idfPdfTemplate: number) {
  return await API.delete<void>(`/pdf-templates/${idfPdfTemplate}`)
}

/* PDF 템플릿 lastUsed 갱신 */
export async function updatePdfTemplateLastUsed(idfPdfTemplate: number) {
  return await API.put<void>(`/pdf-templates/${idfPdfTemplate}/last-used`)
}
